// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Campaign Rules Tab CSS Module
 * Shared styles for the rules tab across every campaign type
 */
.RJyBnNuRYGQmXLHh0DB2 {
  width: 100%;
  max-width: var(--campaign-tab-width);
  margin: 0 auto 10px;
  flex: 1;
  overflow-y: auto;
}
.FyYbr8ot79lDQwsHMqWN {
  height: 200px;
  width: 100%;
  position: relative;
  display: block;
}
.cFHwtEvU5oMZJFzjOV3M {
  border-radius: 12px;
  overflow: hidden;
  padding: 1px;
}
.crGCnLJYtFCfEhGfZROA {
  display: flow-root;
  width: 100%;
  padding: 13.5px;
  background-color: #212121;
  border-radius: 12px;
  visibility: visible;
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);
  border: 1.5px solid rgba(39, 39, 39, 0.5);
}
.LlgGdWTlQA3MDk9Katgl {
  color: #d4d4d4;
  text-align: left;
  letter-spacing: 0.18px;
  font-size: 21px;
  width: 100%;
  height: auto;
  line-height: 1.3;
}
.LlgGdWTlQA3MDk9Katgl > * + * {
  margin-top: 14px;
}
/* Terms Info icon */
.crGCnLJYtFCfEhGfZROA > picture {
  float: right;
  height: 40px;
  margin: 0 0 13.5px 13.5px;
}
.bF6q1NXGBrZ6kriLKfaS {
  display: block;
  cursor: pointer;
  width: auto;
  height: 100%;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .crGCnLJYtFCfEhGfZROA {
    padding: 9px;
    border-width: 1px;
  }
  .LlgGdWTlQA3MDk9Katgl {
    font-size: 15px;
  }
  .crGCnLJYtFCfEhGfZROA > picture {
    height: 36px;
    margin: 0 0 9px 9px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (orientation: portrait) and (max-color:2147477350) {
  .crGCnLJYtFCfEhGfZROA,
  .cFHwtEvU5oMZJFzjOV3M {
    border-radius: 8px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (orientation: portrait) and (color:2147477350) {
  .crGCnLJYtFCfEhGfZROA,
  .cFHwtEvU5oMZJFzjOV3M {
    border-radius: 8px;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/tabs/RulesTab/css/RulesTab.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA,oBAAoB;AACpB;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;AACF;AACA;AAAA;EACE;;IAEE,kBAAkB;EACpB;AACF;AAAA;AALA;AAAA;AAAA;AAAA;EACE;;IAEE,kBAAkB;EACpB;AACF;AAAA;AAAA;AAAA","sourcesContent":["/**\n * Campaign Rules Tab CSS Module\n * Shared styles for the rules tab across every campaign type\n */\n.rulesWrapper {\n  width: 100%;\n  max-width: var(--campaign-tab-width);\n  margin: 0 auto 10px;\n  flex: 1;\n  overflow-y: auto;\n}\n.loaderContainer {\n  height: 200px;\n  width: 100%;\n  position: relative;\n  display: block;\n}\n.contentContainerWrapper {\n  border-radius: 12px;\n  overflow: hidden;\n  padding: 1px;\n}\n.contentContainer {\n  display: flow-root;\n  width: 100%;\n  padding: 13.5px;\n  background-color: #212121;\n  border-radius: 12px;\n  visibility: visible;\n  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);\n  border: 1.5px solid rgba(39, 39, 39, 0.5);\n}\n.textSection {\n  color: #d4d4d4;\n  text-align: left;\n  letter-spacing: 0.18px;\n  font-size: 21px;\n  width: 100%;\n  height: auto;\n  line-height: 1.3;\n}\n.textSection > * + * {\n  margin-top: 14px;\n}\n/* Terms Info icon */\n.contentContainer > picture {\n  float: right;\n  height: 40px;\n  margin: 0 0 13.5px 13.5px;\n}\n.infoIcon {\n  display: block;\n  cursor: pointer;\n  width: auto;\n  height: 100%;\n}\n@media (--campaign-mobile) {\n  .contentContainer {\n    padding: 9px;\n    border-width: 1px;\n  }\n  .textSection {\n    font-size: 15px;\n  }\n  .contentContainer > picture {\n    height: 36px;\n    margin: 0 0 9px 9px;\n  }\n}\n@media (orientation: portrait) and (--campaign-mobile) {\n  .contentContainer,\n  .contentContainerWrapper {\n    border-radius: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rulesWrapper": `RJyBnNuRYGQmXLHh0DB2`,
	"loaderContainer": `FyYbr8ot79lDQwsHMqWN`,
	"contentContainerWrapper": `cFHwtEvU5oMZJFzjOV3M`,
	"contentContainer": `crGCnLJYtFCfEhGfZROA`,
	"textSection": `LlgGdWTlQA3MDk9Katgl`,
	"infoIcon": `bF6q1NXGBrZ6kriLKfaS`
};
export default ___CSS_LOADER_EXPORT___;
